/**
 * SortBar.jsx
 *
 * Barre de tri avec sélecteurs Ant Design
 */

import React from "react";
import { Space, Select, Button } from "antd";
import { ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons";

/**
 * SortBar - Contrôles de tri
 */
export default function SortBar({ sortBy, setSortBy, order, setOrder }) {
    const sortOptions = [
        { label: "Date", value: "date" },
        { label: "Prix", value: "price" },
        { label: "Nom", value: "name" },
    ];

    return (
        <Space style={{ padding: "16px", width: "100%", justifyContent: "flex-start" }} size="middle">
            <span style={{ fontWeight: "600" }}>Trier par :</span>

            <Select
                value={sortBy}
                onChange={setSortBy}
                options={sortOptions}
                style={{ width: "150px" }}
            />

            <Button.Group>
                <Button
                    icon={<ArrowDownOutlined />}
                    onClick={() => setOrder("desc")}
                    type={order === "desc" ? "primary" : "default"}
                >
                    Descendant
                </Button>
                <Button
                    icon={<ArrowUpOutlined />}
                    onClick={() => setOrder("asc")}
                    type={order === "asc" ? "primary" : "default"}
                >
                    Ascendant
                </Button>
            </Button.Group>
        </Space>
    );
}